import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'
import { FormattedMessage } from 'react-intl'
import { parseHubErrorMessage } from '../utils'
import './ErrorPopover.module.scss'

const propTypes = {
  /**
   * Error message string
   */
  error: PropTypes.string,
  /**
   * Class to override default styles
   */
  className: PropTypes.string,
}

function ErrorPopover(props) {
  const { error = null, className = '' } = props ?? {}

  if (!error) {
    return null
  }

  const errorMessage = parseHubErrorMessage(error)
  return (
    <OverlayTrigger
      overlay={
        <Tooltip id="posture-error" className="Uic-ErrorPopover-tooltip">
          <div className="mb-2">
            <i className={clsx('fas fa-triangle-exclamation me-2', 'Uic-ErrorPopover-fontWarning')} />

            <span className="Uic-ErrorPopover-fontBold">
              <FormattedMessage id="UIC.GENERAL.ERROR" />
            </span>
          </div>
          {errorMessage}
        </Tooltip>
      }
    >
      <i className={clsx('fas fa-triangle-exclamation', 'Uic-ErrorPopover-fontWarning', className)} />
    </OverlayTrigger>
  )
}

ErrorPopover.propTypes = propTypes

export default ErrorPopover
